module.exports = __webpack_public_path__ + "55543faa631839642082d150ac2f14fa.svg";